module.exports = __webpack_public_path__ + "img/banner.8479c5c9.png";